import React from 'react'

export const LoadingContext = React.createContext({
    // isLoad: false,
    setIsLoad: () => { },
    // isOpenToast: false,
    // setIsOpenToast: () => { },
    // alertMessage: '',
    // setAlertMessage: () => { },
    // colorSnack: '',
    // setColorSnack: () => { },
    // alertFunction: '',
    // setAlertFunction: () => { },
    DEFAULTURL: '',
    toastMessages: () => { },
    // handleClose: () => { },
    useComma: true,
    setUseComma: () => { },
    primaryColor: '',
    secondaryColor: '',
    tertiaryColor: '',
    passValue: new Map(),
    setPassValue: () => { },
})